import * as constants from './constants';
import { fetchFromRTM } from '../RTMResolvers';

export default (() => {
  async function learnerPluginLog(learnerArgs) {
    const message = {
      type: constants.RTM_LEARNER_PLUGIN_LOG,
      ...learnerArgs,
    };

    const response = await fetchFromRTM(
      message,
      constants.RTM_LEARNER_PLUGIN_LOG_OK,
      constants.RTM_LEARNER_PLUGIN_LOG_ERROR
    );

    return response;
  }

  return {
    learnerPluginLog,
  };
})();
